// Rol tabanlı renk tokenları.
// "black" = birincil ön plan (metin, birincil buton, kendi baloncuğun)
// "white" = birincil arka plan (ekran zemini, birincil buton üstü metin)
// Karanlık modda bu roller ters çevrilir; isimler aynı kalır ki
// ekranların dönüştürülmesi tamamen mekanik olsun (colors. → c.).

export type ThemeColors = {
  black: string;
  white: string;
  gray100: string;
  gray200: string;
  gray400: string;
  gray600: string;
};

export const lightColors: ThemeColors = {
  black: '#000000',
  white: '#FFFFFF',
  gray100: '#F5F5F5',
  gray200: '#E5E5E5',
  gray400: '#9E9E9E',
  gray600: '#616161',
};

export const darkColors: ThemeColors = {
  black: '#FFFFFF', // ön plan (metin) — dark'ta açık
  white: '#121212', // zemin — dark'ta koyu
  gray100: '#1E1E1E', // ince yüzey (diğer baloncuk, ayraç, input)
  gray200: '#2C2C2E', // kenarlık, pasif
  gray400: '#8E8E93', // ikincil metin
  gray600: '#AEAEB2', // üçüncül metin
};

// Geriye dönük uyum: henüz temaya bağlanmamış ekranlar bunu (açık palet) kullanır.
export const colors = lightColors;

export const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
};

export const fontSize = {
  sm: 13,
  md: 16,
  lg: 20,
  xl: 28,
};

/**
 * Köşe yuvarlaklığı ölçeği (7.14 · D-540).
 *
 * D-506 dördüncü sapma olarak "yarıçap ölçeği yok"u kaydetti. Ölçüm bunu
 * daralttı: ölçek büyük ölçüde zaten vardı, uygulanmamıştı. Buradaki dört
 * değerin hiçbiri icat edilmedi; dördü de bugün anlamıyla kullanımdaydı.
 *
 * `control` zaten `formControlMetrics` içinde duruyordu ve 18 yer onu
 * görmezden gelip elle 10 yazmıştı — sapmanın en büyük tek parçası buydu.
 *
 * Ölçeğin DIŞINDA kalan iki şey var ve bilerek dışarıda:
 *
 * - **Daire ve hap:** yarıçap, kısa kenarın yarısıdır. Bu bir ölçek basamağı
 *   değil, boyuttan türeyen bir kural; avatar, cam kontrol, dock ve tema
 *   seçenekleri buradan gelir.
 * - **İşaretler:** nokta, kuyruk, rozet, onay kutusu gibi 44 pt dokunma
 *   tabanının altındaki çizim parçaları. `control`u onlara uygulamak
 *   yanlış olurdu: 24 px'lik onay kutusuna 12 vermek onu daireye çevirir,
 *   yani onay kutusunu radyo düğmesi gibi gösterirdi.
 */
export const radius = {
  /** Kasıtlı keskin köşe — fotoğraf ve görsel balonu (D-164). */
  square: 0,
  /** Kontrol ve girdi; yalnız 44 pt tabanındaki öğeler için. */
  control: 12,
  /** Tek başına duran yüzey: kart, bölüm, balon, pano. */
  card: 16,
  /** İki katmanlı yüzeyin İÇ okuma alanı (D-342). */
  layerInner: 18,
  /** İki katmanlı yüzeyin DIŞ kapsayıcısı (D-342). */
  layerOuter: 24,
} as const;

// Form satırlarında yan yana veya alt alta duran alanların optik geometrisi.
// Tek bir token, tarih/saat düğmeleriyle süre ve metin alanlarının farklı
// ekranlarda birkaç piksel ayrışmasını önler.
export const formControlMetrics = {
  height: 48,
  borderRadius: radius.control,
  borderWidth: 1,
} as const;
